<!-- Per-page orientation override disabled for now; report-level orientation (pv-report-settings)
     is still the source of truth. Rework planned later — see deferred-work.md. -->
<!--
<div class="settings-subheading" *ngIf="showOrientation">Layout</div>

<form *ngIf="showOrientation" [formGroup]="formGroup" autocomplete="off">
    <div class="field-block">
        <label class="field-label">Orientation</label>
        <mat-form-field appearance="outline" class="full-width">
            <mat-select formControlName="pageOrientation">
                <mat-option value="portrait">Portrait</mat-option>
                <mat-option value="landscape">Landscape</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</form>
-->

<div class="settings-subheading">Font</div>

<pv-inheritable-typography
    [parent]="parentTypography"
    [value]="pageTypography"
    parentLabel="From report"
    (valueChange)="onTypographyChange($event)">
</pv-inheritable-typography>
